import React, { useEffect, useState } from 'react';

// Auto-discovers every image dropped into src/assets/hero-images — add a new
// file there and it shows up in the hero rotation on the next build, no code change needed.
const heroImagesContext = require.context('../../assets/hero-images', false, /\.(png|jpe?g|svg)$/i);
const heroImages = heroImagesContext.keys().map((key) => heroImagesContext(key));

const HeroImageSlideshow = ({ alt }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (heroImages.length <= 1) return;
    const interval = setInterval(() => {
      setActiveIndex((prev) => {
        let next = Math.floor(Math.random() * heroImages.length);
        while (next === prev) {
          next = Math.floor(Math.random() * heroImages.length);
        }
        return next;
      });
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative h-full min-h-[420px] bg-white/5 rounded-sm overflow-hidden">
      {heroImages.map((src, idx) => (
        <img
          key={src}
          src={src}
          alt={alt}
          className={`hero-slideshow-img absolute inset-0 w-full h-full object-contain object-center ${
            idx === activeIndex ? 'opacity-100' : 'opacity-0'
          }`}
        />
      ))}
    </div>
  );
};

export default HeroImageSlideshow;
